import { html } from './environment'

const rootStyles = getComputedStyle(html)

const fullVw = window.innerWidth
const containerPadding = parseFloat(rootStyles.getPropertyValue('--container-padding')) * parseFloat(getComputedStyle(html).fontSize)
const gridColumns = parseFloat(rootStyles.getPropertyValue('--grid-columns'))

const calculatedValue = ((fullVw - (containerPadding * 2)) / gridColumns).toFixed(2)

const columnSize = parseInt(calculatedValue)

export { columnSize }
